/* eslint-disable max-len */
import classNames from 'classnames';
import {reverse} from 'core/urls';
import {isSupervisor} from 'core/utils';
import faqsQuery from 'graphql/queries/faqs.gql';
import termsAndConditionsQuery from 'graphql/queries/terms-and-conditions.gql';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {compose, graphql} from 'react-apollo';
import MenuLink from '../menu-link/index';
import User from '../user';
import styles from './styles.less';

@compose(
    graphql(termsAndConditionsQuery, {name: 'termsQuery'}),
    graphql(faqsQuery, {name: 'faqsQuery'}),
)
export default class Menu extends Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        user: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
        onSessionOrganizationChange: PropTypes.func,
    };

    render() {
        const {user, faqsQuery, termsQuery, onSessionOrganizationChange, onClose, visible} = this.props;

        const shouldRenderFAQs = faqsQuery.faqs && Boolean(faqsQuery.faqs.length);
        const shouldRenderTermsAndConditions = termsQuery.termsAndConditions && Boolean(termsQuery.termsAndConditions.length);

        return (
            <div className={classNames(styles.root, {[styles.show]: visible})}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <User
                            vertical
                            user={user}
                            onClick={onClose}
                            onSessionOrganizationChange={onSessionOrganizationChange}
                        />
                    </div>
                    <div className={styles.body}>
                        <MenuLink
                            onClose={onClose}
                            user={user}
                            categories={[{to: reverse('home'), label: 'Inicio'}]}
                        />
                        <MenuLink
                            onClose={onClose}
                            isCollapse
                            user={user}
                            label='Pedidos Distribuidor'
                            categories={[
                                {to: reverse('merchandising'), label: 'Merchandising', permissions: ['merchandising']},
                                {to: reverse('clDealerRefundCreate'), label: 'Campo Líder ', permissions: ['clDealerCrops', 'clDealerKits', 'clDealerRefund']},
                                {to: reverse('rtiDealerHome'), label: 'RTI ', permissions: ['rtiDealerKits', 'rtiDealerRefund']},
                                {to: reverse('jtDealerRefundCreate'), label: 'Jornadas Técnicas', permissions: ['jtDealerRefund']},
                                {to: reverse('advertisingRefundCreate'), label: 'Publicidad', permissions: ['advertisingRefund']},
                                {to: reverse('fenceSignsDealerCreate'), label: 'Carteles de alambrado', permissions: ['fenceSignsDealer']},
                                {to: reverse('loyaltyRefundActions'), label: 'Viajes de Fidelización', permissions: ['loyaltyDealerRefund']},
                                {to: reverse('drones'), label: 'Drones', permissions: ['drones']},
                                {to: reverse('RouteSignsCreate'), label: 'Carteles en ruta ', permissions: ['routeSignsDealerRefund']},
                                {to: reverse('otherDealerRefundCreate'), label: 'Otras acciones', permissions: ['otherDealerRefund']},
                            ]}
                        />
                        <MenuLink
                            onClose={onClose}
                            isCollapse
                            user={user}
                            label='Pedidos Multiplicador'
                            categories={[
                                {to: reverse('clMultiplierHome'), label: 'Campo Líder', permissions: ['clMultiplierCrops', 'clMultiplierKits', 'clMultiplierRefund']},
                                {to: reverse('rtiMultiplierHome'), label: 'RTI', permissions: ['rtiMultiplierKits', 'rtiMultiplierRefund']},
                                {to: reverse('jtMultiplierRefundCreate'), label: 'Jornadas Técnicas', permissions: ['jtMultiplierRefund']},
                                {to: reverse('fenceSignsMultiplierCreate'), label: 'Carteles de alambrado', permissions: ['fenceSignsMultiplier']},
                                {to: reverse('llMultiplierHome'), label: 'Lado a Lado', permissions: ['llMultiplierTrialSigns', 'llMultiplierBags']},
                                {to: reverse('otherMultiplierRefundCreate'), label: 'Otras acciones', permissions: ['otherMultiplierRefund']},
                            ]}
                        />
                        <MenuLink
                            onClose={onClose}
                            isCollapse
                            user={user}
                            label='Organización'
                            categories={[
                                {to: reverse('orderList'), label: 'Historial de pedidos'},
                                user.organization.createDealerOrders && {to: reverse('creditSummary', {id: user.organization.id}), label: 'Créditos / Movimientos'},
                                {to: reverse('addressBook'), label: 'Direcciones'},
                            ]}
                        />
                        {isSupervisor(user) &&
                            <MenuLink
                                onClose={onClose}
                                isCollapse
                                user={user}
                                label='Administración'
                                categories={[
                                    {to: reverse('orderList'), label: 'Pedidos'},
                                    user.organization.createDealerOrders && {to: reverse('supervisorCreditSummary'), label: 'Créditos / Movimientos'},
                                    user.isStaff && ({externalTo: '/admin/', label: 'Ingresar al admin'}),
                                    {externalTo: 'https://experiencianidera.com/apps/biblioteca/app/index.php', target: '_blank', label: 'Ingresar a la Biblioteca'},
                                ]}
                            />
                        }
                        <MenuLink onClose={onClose} categories={[{to: reverse('profile'), label: 'Datos personales'}]} />
                        <MenuLink onClose={onClose} categories={[{to: reverse('contactForm'), label: 'Contacto'}]} />
                        {shouldRenderFAQs &&
                            <MenuLink onClose={onClose} categories={[{to: reverse('faq'), label: 'Preguntas frecuentes'}]} />
                        }
                        {shouldRenderTermsAndConditions &&
                            <MenuLink onClose={onClose} categories={[{to: reverse('termsAndConditions'), label: 'Bases y condiciones'}]} />
                        }
                        <MenuLink onClose={onClose} categories={[{externalTo: `${window.SSO_UI_URL}/logout`, label: 'Salir'}]} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/header/menu/index.js